import React from 'react';
import PropTypes from 'prop-types';
import {
  GameStatStyled,
  GameStatText,
  GameStatNumber,
} from '../../molecules/GameStats/GameStats.styled';

const TimeRemaining = ({ timeLeft }) => (
  <GameStatStyled>
    <GameStatText>Left</GameStatText>
    <GameStatNumber>
      {timeLeft}
      <small>s</small>
    </GameStatNumber>
  </GameStatStyled>
);

export default TimeRemaining;

TimeRemaining.propTypes = {
  timeLeft: PropTypes.number,
};

TimeRemaining.defaultProps = {
  timeLeft: 0,
};



// WEBPACK FOOTER //
// ./src/components/atoms/TimeRemaining/TimeRemaining.js